import { Component } from 'react';
import { getCurrentFunctionName } from '../../performanceModeManager';
import DailyListMode from '../../containers/Interventions/DisplayModes/DailyListMode';
import ListMode from '../../containers/Interventions/DisplayModes/ListMode';
import { arraysAreSame } from '../../lib/array_helper';

class InterventionsList extends Component {

    shouldComponentUpdate(nextProps) {
        let filteredAndSortedInterventionsChanged = !arraysAreSame(this.props.interventionsFilters.filteredAndSortedInterventions, nextProps.interventionsFilters.filteredAndSortedInterventions, true);
        
        return nextProps.interventionsFilters.currentModeId !== this.props.interventionsFilters.currentModeId 
            || filteredAndSortedInterventionsChanged
    }

    getElementFromDisplayMode(globalContainer) {

        let displayModes = this.props.interventionsFilters.modeList.filter((dm) => dm.id === this.props.interventionsFilters.currentModeId);
        let selectedDisplayMode;

        if (displayModes.length <= 0)
            return null;

        selectedDisplayMode = displayModes[0];

        switch (selectedDisplayMode.id) {
            case 0:
                return (<DailyListMode interventionsFilters={this.props.interventionsFilters}  globalContainer={globalContainer}/>)
            default:
                return (<ListMode interventionsFilters={this.props.interventionsFilters} globalContainer={globalContainer}/>)
        }
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return this.getElementFromDisplayMode(this.props.globalContainer)
    }
}

export default InterventionsList;
